export const DEFAULT_LOCALE = "en_CA";
export const DEFAULT_LANG = "en";

export interface Messages {
    has(key: string): boolean;
    prop(key: string, ...args: unknown[]): string;
}

// ISO format has hyphens (-) and Java format has underscores (_); ensure
// we are using the one we expect to receive in the map
export function toJavaLocaleFormat(localeString?: string): string {
    return localeString?.replace("-", "_") || undefined;
}
